import { PauseIcon } from "@heroicons/react/20/solid";
import { MicrophoneIcon as OutlineMicrophoneIcon } from "@heroicons/react/24/outline";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

type Props = {
  isRecording: boolean;
  startSpeechToText: () => void;
  stopSpeechToText: () => void;
};

export const SpeechToTextButton: FC<Props> = ({
  isRecording,
  stopSpeechToText,
  startSpeechToText,
}) => {
  const { t } = useTranslation();

  const [dots, setDots] = useState("");

  // Effet pour l'animation des points
  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isRecording) {
      interval = setInterval(() => {
        setDots((prevDots) => {
          if (prevDots.length >= 3) return "";
          return prevDots + ".";
        });
      }, 500); // Change un point toutes les 500ms
    } else {
      setDots("");
    }

    return () => clearInterval(interval);
  }, [isRecording]);

  const isChrome = () => {
    return (
      /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
    );
  };

  const handleClick = () => {
    if (!isChrome()) {
      toast.error(t("question.speechToText.notSupported"));
      return;
    }

    if (isRecording) {
      stopSpeechToText();
    } else {
      startSpeechToText();
    }
  };

  const text = isRecording
    ? t("question.speechToText.recording")
    : t("question.speechToText.idle");

  return (
    <button
      onClick={handleClick}
      className={[
        isRecording ? "text-rust-300" : "",
        "border-rust-50 border hover:bg-rust-10 text-rust-50 hover:text-rust-300 font-light py-2 px-2 rounded flex items-center",
      ].join(" ")}
      type="button"
    >
      {isRecording ? (
        <>
          <PauseIcon className="h-5 w-5 mr-2" />
          {text}
          <span className="inline-block w-[2ch] text-left" aria-hidden="true">
            {dots}
          </span>
        </>
      ) : (
        <>
          <OutlineMicrophoneIcon className="h-5 w-5 mr-2" />
          {text}
        </>
      )}
    </button>
  );
};
